export const UPDATE_ME = 'UPDATE_ME';
export const UPDATE_ORG_LIST = 'UPDATE_ORG_LIST';
export const UPDATE_ORG = 'UPDATE_ORG';
export const LOAD_ORG_LIST = 'LOAD_ORG_LIST';
export const LOAD_ORG = 'LOAD_ORG';
export const ADD_APPLICATION_NUM = 'ADD_APPLICATION_NUM';
export const ENTERING_DUPLICATE = 'ENTERING_DUPLICATE';

export const UPDATE_JOB_LIST = 'UPDATE_JOB_LIST';
export const UPDATE_JOB = 'UPDATE_JOB';
export const LOAD_JOB_LIST = 'LOAD_JOB_LIST';
export const LOAD_JOB = 'LOAD_JOB';
export const UPDATE_RELATED_JOBS = 'UPDATE_RELATED_JOBS';

export const UPDATE_EXCEL_APPLICATION_LIST = 'UPDATE_EXCEL_APPLICATION_LIST';
export const LOAD_APPLICATION_LIST = 'LOAD_APPLICATION_LIST';
export const UPDATE_APPLICATION = 'UPDATE_APPLICATION';
export const UPLOAD_CANDIDATE_RESULT = 'UPLOAD_CANDIDATE_RESULT';
export const CLEAR_APPLICATION_INFO = 'CLEAR_APPLICATION_INFO';
export const REPLACE_EXCEL_DUP_APPLICATIONS = 'REPLACE_EXCEL_DUP_APPLICATIONS';
export const CLEAR_EXCEL_DUP_APPLICATIONS = 'CLEAR_EXCEL_DUP_APPLICATIONS';

export const UPLOAD_RESUME = 'UPLOAD_RESUME';

export const REMOVE_TOAST = 'REMOVE_TOAST';

export const UPDATE_COMMENTS = 'UPDATE_COMMENTS';
export const UPDATE_ALL_COMMENTS = 'UPDATE_ALL_COMMENTS';

export const UPDATE_HEADHUNTER_SETTING = 'UPDATE_HEADHUNTER_SETTING';
export const UPDATE_HEADHUNTER_APPLY_FORM = 'UPDATE_HEADHUNTER_APPLY_FORM';
export const UPDATE_OVERSEAS_NUMBER_SETTING = 'UPDATE_OVERSEAS_NUMBER_SETTING';
